import { faPlay } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import ImageWithLoading from '../components/commonElements/imageWithLoading';
import { IMAGE, VIDEO } from '../config/constants';

const CarouselImageCard = ({ image, active, item }) => {
  const [imageError, setImageError] = useState(false);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center position-relative ">
      <div
        style={{
          position: 'absolute',
          borderRadius: '2px',
          top: '2px',
          left: '2px',
          zIndex: 10
        }}
        className="w-20px badge bg-white d-flex justify-content-center align-items-center shadow"
      >
        {item.media_type === VIDEO ? (
          <i className="fa-regular fa-video" style={{ fontSize: '1.25em' }}></i>
        ) : item.media_type === IMAGE ? (
          <i className="fa-regular fa-image" style={{ fontSize: '1.25em' }}></i>
        ) : (
          <i
            className="fa-regular fa-file-pdf text-danger"
            style={{ fontSize: '1.25em' }}
          ></i>
        )}
      </div>

      <div
        className={`h-100px w-100px bg-white d-flex justify-content-center align-items-center`}
      >
        <ImageWithLoading
          src={image}
          alt="placeholder"
          className={`img-thumbnail h-100px w-100px ${
            active && 'border border-primary'
          }`}
          style={{ objectFit: 'cover' }}
          pdf={item.media_type == 'doc'}
        />
      </div>
    </div>
  );
};

export default CarouselImageCard;
